import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.css";
import store from "./store";
import "./locales/index";
import TranslationConfig from "./components/TranslationConfig/TranslationConfig";
import { HelmetProvider } from "react-helmet-async";

import { Provider } from "react-redux";

import { CompatRouter } from "react-router-dom-v5-compat";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <BrowserRouter>
      <CompatRouter>
        <React.Suspense>
          <TranslationConfig>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </TranslationConfig>
        </React.Suspense>
      </CompatRouter>
    </BrowserRouter>
  </Provider>
);
